/**
 * 
 * @param {object} settings cacheKey, cacheName, cacheData, merge
 * @returns 
 */
export const sendMessageToServiceWorker = (settings) => {
  const { cacheKey, cacheName } = settings ?? {}
  if (navigator.serviceWorker && navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage(settings);
    return true
  } else {
    // console.log('-xxx postMessage', cacheKey, cacheName)
    return false
  }
}